<template>
  <div class="site-page nav-content-inset">
    <div class="site-page__inner">
      <h1 class="site-page__title">我的课程 · 学习资源</h1>
      <p class="hint">仅可管理您创建的课程下知识点绑定的学习资源。</p>
      <nav class="creator-knowledge-nav">
        <router-link to="/creator/knowledge/points">知识点</router-link>
        <router-link class="is-active" to="/creator/knowledge/resources">学习资源</router-link>
        <router-link to="/creator/works">返回我的创作</router-link>
      </nav>
      <KnowledgeResourceAdmin creator-mode :initial-kc-id="initialKcId" />
    </div>
  </div>
</template>

<script>
import KnowledgeResourceAdmin from './components/KnowledgeResourceAdmin.vue'

export default {
  name: 'CreatorKnowledgeResourcesView',
  components: { KnowledgeResourceAdmin },
  computed: {
    initialKcId() {
      return this.$route.query.kcId || null
    }
  }
}
</script>

<style scoped>
.hint { color: #666; margin-bottom: 12px; }
.creator-knowledge-nav {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.creator-knowledge-nav a {
  color: #409eff;
  text-decoration: none;
}
.creator-knowledge-nav a.is-active {
  font-weight: 600;
  color: #303133;
}
</style>
